import {
    CREATE_CHANNEL_CONTRACT_BANNER_SET,
    CREATE_CHANNEL_CONTRACT_CHANNEL_NAME_SET,
    CREATE_CHANNEL_CONTRACT_DESCRIPTION_SET,
    CREATE_CHANNEL_CONTRACT_PROFILE_SET,
    CREATE_CHANNEL_CONTRACT_USER_NAME_SET,
} from '../../constants/ceateChannel';
import { combineReducers } from 'redux';

const createChannelProfile = (state = {
    value: '',
}, action) => {
    switch (action.type) {
    case CREATE_CHANNEL_CONTRACT_PROFILE_SET:
        return {
            value: action.value,
        };

    default:
        return state;
    }
};

const createChannelBanner = (state = {
    value: '',
}, action) => {
    switch (action.type) {
    case CREATE_CHANNEL_CONTRACT_BANNER_SET:
        return {
            value: action.value,
        };

    default:
        return state;
    }
};

const createChannelUserName = (state = '', action) => {
    if (action.type === CREATE_CHANNEL_CONTRACT_USER_NAME_SET) {
        return action.value;
    }

    return state;
};

const createChannelContractChannelName = (state = '', action) => {
    if (action.type === CREATE_CHANNEL_CONTRACT_CHANNEL_NAME_SET) {
        return action.value;
    }

    return state;
};

const createChannelDescription = (state = {
    value: '',
    valid: true,
}, action) => {
    switch (action.type) {
    case CREATE_CHANNEL_CONTRACT_DESCRIPTION_SET:
        return {
            value: action.value,
            valid: action.valid,
        };

    default:
        return state;
    }
};

export default combineReducers({
    createChannelProfile,
    createChannelBanner,
    createChannelUserName,
    createChannelContractChannelName,
    createChannelDescription,
});
